import axios from 'axios'
import { host } from '../configuraciones'

//data inicial
const dataInicial = {
    loading: false,
    activo: false,
    data: null,
    tipoUsuario: 0,
    detalle: {},
    user: {},
    login: {},
    cliente: []
}

//types
const LOADING = 'LOADING'
const USUARIO_ERROR = 'USUARIO_ERROR'
const USUARIO_LOGIN_EXITO = 'USUARIO_LOGIN_EXITO'
const USUARIO_REGISTRO_EXITO = 'USUARIO_REGISTRO_EXITO'
const USUARIO_CERRAR_SESION = 'USUARIO_CERRAR_SESION'
const OBTENER_TODOS_USUARIOS_EXITO = 'OBTENER_TODOS_USUARIOS_EXITO'
const OBTENER_TODOS_USUARIOS_ERROR = 'OBTENER_TODOS_USUARIOS_ERROR'
const OBTENER_USUARIO_POR_NOMBRE_EXITO = 'OBTENER_USUARIO_POR_NOMBRE_EXITO'
const OBTENER_USUARIOS_POR_NOMBRE_ERROR = 'OBTENER_USUARIOS_POR_NOMBRE_ERROR'
const OBTENER_USER_EXITO = 'OBTENER_USER_EXITO'
const OBTENER_LOGIN_EXITO = 'OBTENER_LOGIN_EXITO'
const UPDATE_LOGIN_EXITO = 'UPDATE_LOGIN_EXITO'
const OBTENER_CIENTE_EXITO = 'OBTENER_CIENTE_EXITO'
//reducer
export default function usuarioReducer(state = dataInicial, action) {
    switch (action.type) {
        case LOADING:
            return { ...state, loading: true }
        case USUARIO_ERROR:
            return { ...dataInicial }
        case USUARIO_LOGIN_EXITO:
            return { ...state, activo: true, data: action.payload.data }
        case USUARIO_REGISTRO_EXITO:
            return { ...state }
        case USUARIO_CERRAR_SESION:
            return { ...dataInicial }
        case OBTENER_USUARIO_POR_NOMBRE_EXITO:
            return { ...state, tipoUsuario: action.payload }
        case OBTENER_USER_EXITO:
            return { ...state, user: action.payload.user }
        case OBTENER_LOGIN_EXITO:
            return { ...state, login: action.payload.login }
        case UPDATE_LOGIN_EXITO:
            return { ...state, login: action.payload.login }
        case OBTENER_CIENTE_EXITO:
            return { ...state, cliente: action.payload.cliente }
        default:
            return state
    }
}

//actions
export const registrarUsuarioAccion = (data) => async (dispatch) => {

    try {
        const fullUrl = host + `Auth/registrar`
        const res = await axios.post(fullUrl, { data })
        dispatch({
            type: USUARIO_REGISTRO_EXITO,
            payload: { data: res.data.data }
        })
        return true
    } catch (error) {
        console.log(error)
        dispatch({
            type: USUARIO_ERROR
        })
    }
}

export const registrarUsuarioAccionUI = (data) => async (dispatch) => {

    try {
        const fullUrl = host + `Auth/registrarUI`
        const res = await axios.post(fullUrl, { data })
        dispatch({
            type: USUARIO_REGISTRO_EXITO,
            payload: { data: res.data.data }
        })
        return res.data.data
    } catch (error) {
        console.log(error)
        //dispatch({
        //    type: USUARIO_ERROR
        //})
    }
}

export const updateLogin = (data) => async (dispatch) => {
    try {
        const fullUrl = host + `Auth/ActualizarLoginUI`
        const res = await axios.put(fullUrl, { data })
        dispatch({
            type: UPDATE_LOGIN_EXITO,
            payload: { data: res.data.data }
        })
        return res.data.data
    } catch (error) {
        console.log(error)
        //dispatch({
        //    type: USUARIO_ERROR
        //})
    }
}

export const ingresoUsuarioAccion = (data) => async (dispatch) => {
    dispatch({
        type: LOADING
    })
    try {
        const fullUrl = host + `Auth/iniciarSesion`
        const res = await axios.post(fullUrl, { data })
        dispatch({
            type: USUARIO_LOGIN_EXITO,
            payload: { data: res.data.data }
        })
        localStorage.setItem('user', res.data.data.token)
        localStorage.setItem('refreshToken', res.data.data.refreshToken)
        return true
    } catch (error) {
        console.log(error)
        dispatch({
            type: USUARIO_ERROR
        })
    }
}

export const cerrarSesionAccion = () => async (dispatch) => {

    dispatch({
        type: LOADING
    })
    try {
        localStorage.removeItem('user')
        localStorage.removeItem('refreshToken')
        dispatch({
            type: 'USER_LOGOUT'
        })
    } catch (error) {
        console.log(error)
        dispatch({
            type: USUARIO_ERROR
        })
    }

}
export const obtenerTodosLosUsuarios = (usuario) => async (dispatch) => {
    try {
        const fullUrl = host + `AnexoUsuario/obtenerLoginPorusuario/usuario=${usuario.usuario}`
        const res = await axios.get(fullUrl)

        dispatch({
            type: OBTENER_USUARIO_POR_NOMBRE_EXITO,
            payload: res.data.data[0].idtipousuario
        })
        return res
    } catch (error) {
        dispatch({
            type: OBTENER_TODOS_USUARIOS_ERROR
        })

    }
}
export const tokenCheck = (token) => async (dispatch) => {
    try {

        const fullUrl = host + `AnexoUsuario/tokenCheck/${token}`
        const res = await axios.get(fullUrl)

        return res
    } catch (error) {
        console.log(error)

    }
}
export const obtenerContador = (data) => async (dispatch) => {
    try {

        const fullUrl = host + `FC_01/obtenerFC_01_Contador/idestatusdesolicitudes=${data.idestatusdesolicitudes}&idlogin=${data.idlogin}`

        const res = await axios.get(fullUrl)
        return res.data.data[0].count
    } catch (error) {
        console.log(error)
    }
}

export const obtenerUserPorEmail = (email) => async (dispatch) => {
    try {
        const fullUrl = host + `AnexoUsuario/obtenerUserPorEmail/email=${email}`
        const res = await axios.get(fullUrl)
        dispatch({
            type: OBTENER_USER_EXITO,
            payload: { user: res.data.data }
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenerLogin = (id) => async (dispatch) => {
    try {

        const fullUrl = host + `AnexoUsuario/obtenerLogin/${id}`
        const res = await axios.get(fullUrl)

        dispatch({
            type: OBTENER_LOGIN_EXITO,
            payload: { login: res.data.data }
        })
        return res
    } catch (error) {
        console.log(error)

    }
}
export const obtenerCliente = (id) => async (dispatch) => {
    try {

        const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${id}`
        const res = await axios.get(fullUrl)

        dispatch({
            type: OBTENER_CIENTE_EXITO,
            payload: { cliente: res.data.data }
        })
        return res
    } catch (error) {
        console.log(error)

    }
}